import { EditOutlined } from '@ant-design/icons';
import { useQuery } from '@apollo/client';
import { GET_ME, Me, User } from '@frontend/data-access';
import { getLinkLabel } from '@frontend/shared/util';
import { Button, Typography } from 'antd';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';

import UserAvatar from '../../user-avatar/user-avatar';
import UserLevel from '../../user-level/user-level';

function UserProfileHeader({ data }: { data: User }) {
  const { t } = useTranslation('common');
  const { data: meData } = useQuery<{
    me: Me;
  }>(GET_ME);
  const isShowUserBadge = data.role !== 'EXTERNAL_USER';

  return (
    <div className="w-full flex justify-center">
      <div className="space-y-6 lg:w-1/2 w-full">
        <div className="flex flex-wrap lg:flex-nowrap gap-4 lg:gap-9 items-center justify-center">
          <UserAvatar
            size={100}
            badgeSize={40}
            user={data}
            showBadge={isShowUserBadge}
            isClickable={false}
          />
          <div className="flex flex-col gap-1">
            <div className="flex flex-row justify-between items-center gap-2">
              <Typography.Text className="flex-1 !text-gray-900 !text-3xl !font-medium">
                {data?.fullName}
              </Typography.Text>
              {meData?.me?.id === data.id && (
                <Link href="/my-profile/about">
                  <Button shape="circle" icon={<EditOutlined />} />
                </Link>
              )}
            </div>
            <div data-test="profile-role">
              {data?.role && getLinkLabel(data.role.toLowerCase())}
            </div>
            {data?.profile?.title && (
              <div data-test="profile-title">
                {t('profile_title')}: {data?.profile?.title}
              </div>
            )}
            {isShowUserBadge && data && <UserLevel data={data} font="medium" />}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserProfileHeader;
